import React, { useState } from 'react';
import {
  CattleNvdWrapper,
  FormSection,
  CheckboxGroup,
  CheckboxItem,
  ButtonsWrapper,
  FormButton,
  DeclarationText,
  FormHeader,
  FormTitle,
  TwoColumns,
  FormField,
  CattleTable,
  TableWrapper,
  QuestionGroup,
  QuestionLabel,
  RadioGroup,
  DeclarationContainer,
  OutlineButton,
  FormTopHeader,
  // ProgressIndicator,
} from './cattleNvd.style';

const SheepNvd = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({
    // NVD Number
    nvdNumber: '',

    // Owner/sheep details
    fullTradingName: '',
    propertyAddress: '',
    propertyTown: '',
    propertyState: '',
    propertyPostcode: '',
    propertyPIC: '',

    // Sheep description
    sheepDescription: [
      {
        number: '',
        yearBorn: '',
        description: '',
        monthOfShearing: '',
        picOrBrand: '',
        earmarks: '',
      },
    ],

    // Total and NLIS information
    totalSheep: '',
    nlisDevicesNumber: '',
    hoursOffFeed: '',

    // Consignment details
    consignedTo: '',
    destinationAddress: '',
    destinationPIC: '',

    // Part A Questions
    independentlyAudited: '', // Yes/No
    independentlyAuditedDetails: '',
    scabbyMouthVaccination: '', // Yes/No
    bredByOwnerVendor: '', // Yes/No
    breedingDetails: '', // A/B/C/D options
    obtainedPurchasedDetails: '',

    // Chemical residue questions (4-7)
    withholdingPeriod: '', // Yes/No
    withholdingPeriodDetails: '',
    materialConsumed60Days: '', // Yes/No
    materialConsumedDetails: '',
    animalFats: '', // Yes/No
    additionalInfo: '',

    // Declaration
    declarantName: '',
    declarantAddress: '',
    phone: '',
    fax: '',
    email: '',
    signature: '',
    date: '',

    // Part B - Transport details
    movementCommenced: '',
    vehicleRegistration: '',
    transporterName: '',
    transporterSignature: '',
    transporterDate: '',
    transporterTelNo: '',

    // Document details
    documentType: '',
    documentNumber: '',
    officeOfIssue: '',
    expiryDate: '',
  });

  const steps = [
    'NVD & Owner Details',
    'Sheep Description',
    'Consignment Details',
    'Part A - Questions 1-3',
    'Part A - Questions 4-7',
    'Declaration',
    'Part B - Transport',
  ];

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSheepDescriptionChange = (index, field, value) => {
    const newSheepDescription = [...formData.sheepDescription];
    newSheepDescription[index] = {
      ...newSheepDescription[index],
      [field]: value,
    };
    setFormData((prev) => ({
      ...prev,
      sheepDescription: newSheepDescription,
    }));
  };

  const addSheepRow = () => {
    setFormData((prev) => ({
      ...prev,
      sheepDescription: [
        ...prev.sheepDescription,
        {
          number: '',
          yearBorn: '',
          description: '',
          monthOfShearing: '',
          picOrBrand: '',
          earmarks: '',
        },
      ],
    }));
  };

  const removeSheepRow = (index) => {
    if (formData.sheepDescription.length > 1) {
      setFormData((prev) => ({
        ...prev,
        sheepDescription: prev.sheepDescription.filter((_, i) => i !== index),
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Sheep NVD Form Data:', formData);
    alert('Sheep NVD Form submitted successfully!');
  };

  const nextStep = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep((prev) => prev + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep((prev) => prev - 1);
    }
  };

  const renderStep = () => {
    switch (currentStep) {
      case 0:
        return (
          <FormSection>
            <FormField>
              <label>NVD No:</label>
              <input
                type="text"
                name="nvd-number"
                value={formData.nvdNumber}
                onChange={(e) => handleInputChange('nvdNumber', e.target.value)}
                placeholder="Enter NVD Number (e.g., S0720 3888888888)"
                required
              />
            </FormField>

            <FormSection className="part-a-section">
              <h3 className="section-title">Part A - Owner Details</h3>
              <p className="section-subtitle">
                To be completed by the owner or person who is responsible for the husbandry of the
                sheep or lambs.
              </p>

              <div className="subsection">
                <h4 className="subsection-title">Owner of sheep or lambs</h4>
                <FormField>
                  <label>Full Trading Name *</label>
                  <input
                    type="text"
                    name="full-trading-name"
                    value={formData.fullTradingName}
                    onChange={(e) => handleInputChange('fullTradingName', e.target.value)}
                    placeholder="Enter full trading name"
                    required
                  />
                </FormField>
              </div>

              <div className="subsection">
                <h4 className="subsection-title">Property/place where the journey commenced</h4>
                <TwoColumns>
                  <FormField>
                    <label>Address *</label>
                    <input
                      type="text"
                      name="property-address"
                      value={formData.propertyAddress}
                      onChange={(e) => handleInputChange('propertyAddress', e.target.value)}
                      placeholder="Enter property address"
                      required
                    />
                  </FormField>
                  <FormField>
                    <label>Town/Suburb *</label>
                    <input
                      type="text"
                      name="property-town"
                      value={formData.propertyTown}
                      onChange={(e) => handleInputChange('propertyTown', e.target.value)}
                      placeholder="Enter town/suburb"
                      required
                    />
                  </FormField>
                  <FormField>
                    <label>State *</label>
                    <select
                      name="property-state"
                      value={formData.propertyState}
                      onChange={(e) => handleInputChange('propertyState', e.target.value)}
                      required
                    >
                      <option value="">Select State</option>
                      <option value="NSW">NSW</option>
                      <option value="VIC">VIC</option>
                      <option value="QLD">QLD</option>
                      <option value="WA">WA</option>
                      <option value="SA">SA</option>
                      <option value="TAS">TAS</option>
                      <option value="NT">NT</option>
                      <option value="ACT">ACT</option>
                    </select>
                  </FormField>
                  <FormField>
                    <label>Postcode</label>
                    <input
                      type="text"
                      name="property-postcode"
                      value={formData.propertyPostcode}
                      onChange={(e) => handleInputChange('propertyPostcode', e.target.value)}
                      placeholder="Enter postcode"
                    />
                  </FormField>
                </TwoColumns>
                <FormField>
                  <label>Property Identification Code (PIC) of this property *</label>
                  <input
                    type="text"
                    name="property-pic"
                    value={formData.propertyPIC}
                    onChange={(e) => handleInputChange('propertyPIC', e.target.value)}
                    placeholder="Enter Property Identification Code"
                    required
                  />
                </FormField>
              </div>
            </FormSection>
          </FormSection>
        );

      case 1:
        return (
          <FormSection>
            <FormHeader>
              <h3 className="section-title">Description of sheep or lambs</h3>
            </FormHeader>

            <TableWrapper>
              <CattleTable>
                <thead>
                  <tr>
                    <th>Number</th>
                    <th>Year born</th>
                    <th>Description (BREED, SEX & TYPE e.g. ewe, ram)</th>
                    <th>Month of shearing</th>
                    <th>PIC or Brand on Ear Tags</th>
                    <th>Earmarks</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {formData.sheepDescription.map((row, index) => (
                    <tr key={index}>
                      <td>
                        <input
                          type="number"
                          value={row.number}
                          onChange={(e) =>
                            handleSheepDescriptionChange(index, 'number', e.target.value)
                          }
                          placeholder="Qty"
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          value={row.yearBorn}
                          onChange={(e) =>
                            handleSheepDescriptionChange(index, 'yearBorn', e.target.value)
                          }
                          placeholder="Year"
                          min="1900"
                          max="2030"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={row.description}
                          onChange={(e) =>
                            handleSheepDescriptionChange(index, 'description', e.target.value)
                          }
                          placeholder="e.g., BL X Mer Hoggets"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={row.monthOfShearing}
                          onChange={(e) =>
                            handleSheepDescriptionChange(index, 'monthOfShearing', e.target.value)
                          }
                          placeholder="Month/Year"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={row.picOrBrand}
                          onChange={(e) =>
                            handleSheepDescriptionChange(index, 'picOrBrand', e.target.value)
                          }
                          placeholder="PIC/Brand"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={row.earmarks}
                          onChange={(e) =>
                            handleSheepDescriptionChange(index, 'earmarks', e.target.value)
                          }
                          placeholder="Earmarks"
                        />
                      </td>
                      <td>
                        <FormButton
                          type="button"
                          onClick={() => removeSheepRow(index)}
                          className="remove-btn"
                          disabled={formData.sheepDescription.length === 1}
                        >
                          Remove
                        </FormButton>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </CattleTable>
            </TableWrapper>

            <FormButton type="button" onClick={addSheepRow}>
              + Add Row
            </FormButton>

            <div className="subsection" style={{ marginTop: '20px' }}>
              <TwoColumns>
                <FormField>
                  <label>Total</label>
                  <input
                    type="number"
                    name="total-sheep"
                    value={formData.totalSheep}
                    onChange={(e) => handleInputChange('totalSheep', e.target.value)}
                    placeholder="Total number of sheep/lambs"
                  />
                </FormField>
                <div></div>
              </TwoColumns>

              <QuestionGroup>
                <QuestionLabel>
                  A. Have PICs on all of the NLIS tags only on sheep in this consignment been listed
                  in the Description table above? (Other than the PIC printed on this NVD)?
                </QuestionLabel>
                <RadioGroup>
                  <label className="radio-option">
                    <input type="radio" name="pics-listed" value="yes" />
                    <span className="radio-label">Yes ✓</span>
                  </label>
                  <label className="radio-option">
                    <input type="radio" name="pics-listed" value="no" />
                    <span className="radio-label">No</span>
                  </label>
                  <label className="radio-option">
                    <input type="radio" name="pics-listed" value="na" />
                    <span className="radio-label">OR</span>
                  </label>
                </RadioGroup>
              </QuestionGroup>

              <QuestionGroup>
                <QuestionLabel>
                  B. Have all sheep in this consignment been tagged with an NLIS tag with the PIC
                  printed on this NVD* or its associated WA brand as shown in the Description table
                  above?
                </QuestionLabel>
                <RadioGroup>
                  <label className="radio-option">
                    <input type="radio" name="nlis-tagged" value="yes" />
                    <span className="radio-label">Yes</span>
                  </label>
                  <label className="radio-option">
                    <input type="radio" name="nlis-tagged" value="no" />
                    <span className="radio-label">No</span>
                  </label>
                  <label className="radio-option">
                    <input type="radio" name="nlis-tagged" value="minor" />
                    <span className="radio-label">MINOR</span>
                  </label>
                </RadioGroup>
              </QuestionGroup>

              <TwoColumns>
                <FormField>
                  <label>Number of electronic NLIS devices in this consignment</label>
                  <input
                    type="number"
                    name="nlis-devices"
                    value={formData.nlisDevicesNumber}
                    onChange={(e) => handleInputChange('nlisDevicesNumber', e.target.value)}
                    placeholder="Enter number"
                  />
                </FormField>
                <FormField>
                  <label>Hours off feed and water before transporting</label>
                  <input
                    type="text"
                    name="hours-off-feed"
                    value={formData.hoursOffFeed}
                    onChange={(e) => handleInputChange('hoursOffFeed', e.target.value)}
                    placeholder="Enter hours"
                  />
                </FormField>
              </TwoColumns>
            </div>
          </FormSection>
        );

      case 2:
        return (
          <FormSection>
            <FormHeader>
              <h3 className="section-title">Consignment Details</h3>
            </FormHeader>

            <FormField>
              <label>Consigned to *</label>
              <input
                type="text"
                name="consigned-to"
                value={formData.consignedTo}
                onChange={(e) => handleInputChange('consignedTo', e.target.value)}
                placeholder="Enter consignee name"
                required
              />
            </FormField>

            <FormField>
              <label>Destination (if different) of sheep or lambs *</label>
              <input
                type="text"
                name="destination-address"
                value={formData.destinationAddress}
                onChange={(e) => handleInputChange('destinationAddress', e.target.value)}
                placeholder="Enter destination address"
                required
              />
            </FormField>

            <FormField>
              <label>Destination PIC (REQ: WA & TAS)</label>
              <input
                type="text"
                name="destination-pic"
                value={formData.destinationPIC}
                onChange={(e) => handleInputChange('destinationPIC', e.target.value)}
                placeholder="Enter destination PIC"
              />
            </FormField>

            <div className="subsection">
              <h4 className="subsection-title">
                Details of other statutory documents relating to this movement e.g. health statement
              </h4>
              <TwoColumns>
                <FormField>
                  <label>Document Type</label>
                  <input
                    type="text"
                    name="document-type"
                    value={formData.documentType}
                    onChange={(e) => handleInputChange('documentType', e.target.value)}
                    placeholder="Enter document type"
                  />
                </FormField>
                <FormField>
                  <label>Number</label>
                  <input
                    type="text"
                    name="document-number"
                    value={formData.documentNumber}
                    onChange={(e) => handleInputChange('documentNumber', e.target.value)}
                    placeholder="Enter document number"
                  />
                </FormField>
                <FormField>
                  <label>Office of Issue</label>
                  <input
                    type="text"
                    name="office-of-issue"
                    value={formData.officeOfIssue}
                    onChange={(e) => handleInputChange('officeOfIssue', e.target.value)}
                    placeholder="Enter office of issue"
                  />
                </FormField>
                <FormField>
                  <label>Expiry Date</label>
                  <input
                    type="date"
                    name="expiry-date"
                    value={formData.expiryDate}
                    onChange={(e) => handleInputChange('expiryDate', e.target.value)}
                  />
                </FormField>
              </TwoColumns>
            </div>
          </FormSection>
        );

      case 3:
        return (
          <FormSection>
            <FormHeader>
              <h3 className="section-title">Part A - Questions 1-3</h3>
            </FormHeader>

            <QuestionGroup>
              <QuestionLabel>
                1. Have these sheep or lambs been raised consistent with the rules of an
                independently audited QA program whereby the PIC of which is shown above?
              </QuestionLabel>
              <RadioGroup>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="independently-audited"
                    value="yes"
                    checked={formData.independentlyAudited === 'yes'}
                    onChange={(e) => handleInputChange('independentlyAudited', e.target.value)}
                  />
                  <span className="radio-label">Yes ✓</span>
                </label>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="independently-audited"
                    value="no"
                    checked={formData.independentlyAudited === 'no'}
                    onChange={(e) => handleInputChange('independentlyAudited', e.target.value)}
                  />
                  <span className="radio-label">No</span>
                </label>
              </RadioGroup>
              <FormField style={{ marginTop: '10px' }}>
                <input
                  type="text"
                  value={formData.independentlyAuditedDetails}
                  onChange={(e) => handleInputChange('independentlyAuditedDetails', e.target.value)}
                  placeholder="If Yes, give details:"
                />
              </FormField>
            </QuestionGroup>

            <QuestionGroup>
              <QuestionLabel>
                2. Have all the sheep or lambs in this consignment been treated with a Scabby Mouth
                Vaccination either at marking or at least 14 days prior to their presentation for
                sale?
              </QuestionLabel>
              <RadioGroup>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="scabby-mouth-vaccination"
                    value="yes"
                    checked={formData.scabbyMouthVaccination === 'yes'}
                    onChange={(e) => handleInputChange('scabbyMouthVaccination', e.target.value)}
                  />
                  <span className="radio-label">Yes</span>
                </label>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="scabby-mouth-vaccination"
                    value="no"
                    checked={formData.scabbyMouthVaccination === 'no'}
                    onChange={(e) => handleInputChange('scabbyMouthVaccination', e.target.value)}
                  />
                  <span className="radio-label">No ✓</span>
                </label>
              </RadioGroup>
            </QuestionGroup>

            <QuestionGroup>
              <QuestionLabel>
                3. Were all of these sheep or lambs bred by the owner or vendor?
              </QuestionLabel>
              <RadioGroup>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="bred-by-owner"
                    value="yes"
                    checked={formData.bredByOwnerVendor === 'yes'}
                    onChange={(e) => handleInputChange('bredByOwnerVendor', e.target.value)}
                  />
                  <span className="radio-label">Yes</span>
                </label>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="bred-by-owner"
                    value="no"
                    checked={formData.bredByOwnerVendor === 'no'}
                    onChange={(e) => handleInputChange('bredByOwnerVendor', e.target.value)}
                  />
                  <span className="radio-label">No ✓</span>
                </label>
              </RadioGroup>

              <div style={{ marginTop: '10px' }}>
                <p>
                  If No, how long ago were the sheep or lambs obtained or purchased? (If purchased
                  at different times, tick the box corresponding to the time of the most recent
                  purchase.)
                </p>
                <CheckboxGroup>
                  <CheckboxItem>
                    <input
                      type="radio"
                      name="breeding-details"
                      value="A"
                      checked={formData.breedingDetails === 'A'}
                      onChange={(e) => handleInputChange('breedingDetails', e.target.value)}
                    />
                    <span>A. Less than 2 months</span>
                  </CheckboxItem>
                  <CheckboxItem>
                    <input
                      type="radio"
                      name="breeding-details"
                      value="B"
                      checked={formData.breedingDetails === 'B'}
                      onChange={(e) => handleInputChange('breedingDetails', e.target.value)}
                    />
                    <span>B. 2-6 months ✓</span>
                  </CheckboxItem>
                  <CheckboxItem>
                    <input
                      type="radio"
                      name="breeding-details"
                      value="C"
                      checked={formData.breedingDetails === 'C'}
                      onChange={(e) => handleInputChange('breedingDetails', e.target.value)}
                    />
                    <span>C. 6-12 months</span>
                  </CheckboxItem>
                  <CheckboxItem>
                    <input
                      type="radio"
                      name="breeding-details"
                      value="D"
                      checked={formData.breedingDetails === 'D'}
                      onChange={(e) => handleInputChange('breedingDetails', e.target.value)}
                    />
                    <span>D. more than 12 months</span>
                  </CheckboxItem>
                </CheckboxGroup>
              </div>
            </QuestionGroup>
          </FormSection>
        );

      case 4:
        return (
          <FormSection>
            <FormHeader>
              <h3 className="section-title">Part A - Questions 4-7 (Chemical Residue Questions)</h3>
            </FormHeader>

            <QuestionGroup>
              <QuestionLabel>
                4. Are any of the sheep or lambs in this consignment still within a Withholding
                Period (WHP) or Export Slaughter Interval (ESI) as set by APVMA or SAFEMEAT,
                following treatment with any veterinary drug or chemical?
              </QuestionLabel>
              <RadioGroup>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="withholding-period"
                    value="yes"
                    checked={formData.withholdingPeriod === 'yes'}
                    onChange={(e) => handleInputChange('withholdingPeriod', e.target.value)}
                  />
                  <span className="radio-label">Yes</span>
                </label>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="withholding-period"
                    value="no"
                    checked={formData.withholdingPeriod === 'no'}
                    onChange={(e) => handleInputChange('withholdingPeriod', e.target.value)}
                  />
                  <span className="radio-label">No ✓</span>
                </label>
              </RadioGroup>
              <FormField style={{ marginTop: '10px' }}>
                <input
                  type="text"
                  value={formData.withholdingPeriodDetails}
                  onChange={(e) => handleInputChange('withholdingPeriodDetails', e.target.value)}
                  placeholder="If yes, give details:"
                />
              </FormField>
            </QuestionGroup>

            <QuestionGroup>
              <QuestionLabel>
                5. In the past 60 days, have any of the sheep or lambs in this consignment consumed
                any material that was still within a withholding period when harvested, collected or
                first grazed?
              </QuestionLabel>
              <RadioGroup>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="material-consumed-60days"
                    value="yes"
                    checked={formData.materialConsumed60Days === 'yes'}
                    onChange={(e) => handleInputChange('materialConsumed60Days', e.target.value)}
                  />
                  <span className="radio-label">Yes</span>
                </label>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="material-consumed-60days"
                    value="no"
                    checked={formData.materialConsumed60Days === 'no'}
                    onChange={(e) => handleInputChange('materialConsumed60Days', e.target.value)}
                  />
                  <span className="radio-label">No ✓</span>
                </label>
              </RadioGroup>
              <FormField style={{ marginTop: '10px' }}>
                <input
                  type="text"
                  value={formData.materialConsumedDetails}
                  onChange={(e) => handleInputChange('materialConsumedDetails', e.target.value)}
                  placeholder="If Yes, give details:"
                />
              </FormField>
            </QuestionGroup>

            <QuestionGroup>
              <QuestionLabel>
                6. Have the sheep or lambs in this consignment ever in their lives been fed feed
                containing animal fats? (See Explanatory Notes)
              </QuestionLabel>
              <RadioGroup>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="animal-fats"
                    value="yes"
                    checked={formData.animalFats === 'yes'}
                    onChange={(e) => handleInputChange('animalFats', e.target.value)}
                  />
                  <span className="radio-label">Yes</span>
                </label>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="animal-fats"
                    value="no"
                    checked={formData.animalFats === 'no'}
                    onChange={(e) => handleInputChange('animalFats', e.target.value)}
                  />
                  <span className="radio-label">No ✓</span>
                </label>
              </RadioGroup>
            </QuestionGroup>

            <FormField className="full-width">
              <label>
                7. Please include any additional information below (eg: vaccination programs, animal
                health certification, additional declarations, etc.)
              </label>
              <textarea
                name="additional-info"
                value={formData.additionalInfo}
                onChange={(e) => handleInputChange('additionalInfo', e.target.value)}
                rows={4}
                placeholder="Enter any additional information..."
              />
            </FormField>
          </FormSection>
        );

      case 5:
        return (
          <FormSection>
            <FormHeader>
              <h3 className="section-title">Declaration</h3>
            </FormHeader>

            <TwoColumns>
              <FormField>
                <label>Full Name *</label>
                <input
                  type="text"
                  name="declarant-name"
                  value={formData.declarantName}
                  onChange={(e) => handleInputChange('declarantName', e.target.value)}
                  placeholder="Enter full name"
                  required
                />
              </FormField>
              <FormField>
                <label>Full Address *</label>
                <input
                  type="text"
                  name="declarant-address"
                  value={formData.declarantAddress}
                  onChange={(e) => handleInputChange('declarantAddress', e.target.value)}
                  placeholder="Enter full address"
                  required
                />
              </FormField>
            </TwoColumns>

            <TwoColumns>
              <FormField>
                <label>Tel no.</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={(e) => handleInputChange('phone', e.target.value)}
                  placeholder="Enter phone number"
                />
              </FormField>
              <FormField>
                <label>Fax no.</label>
                <input
                  type="tel"
                  name="fax"
                  value={formData.fax}
                  onChange={(e) => handleInputChange('fax', e.target.value)}
                  placeholder="Enter fax number"
                />
              </FormField>
            </TwoColumns>

            <FormField>
              <label>Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={(e) => handleInputChange('email', e.target.value)}
                placeholder="Enter email address"
              />
            </FormField>

            <DeclarationContainer>
              <div className="declaration-text">
                <h4>Declaration Statement</h4>
                <p>
                  I declare that, I am the owner or the person responsible for the husbandry of the
                  sheep or lambs and that all the information in part A of this document is true and
                  correct. I also declare that I have read and understood all the questions that I
                  have answered, that I have read and understood the explanatory notes, and that,
                  while under my control, the sheep or lambs were not fed restricted animal material
                  (including meat and bone meal) in breach of any State or Territory legislation.
                </p>
              </div>

              <TwoColumns>
                <FormField>
                  <label>Signature *</label>
                  <input
                    type="text"
                    name="signature"
                    value={formData.signature}
                    onChange={(e) => handleInputChange('signature', e.target.value)}
                    placeholder="Digital signature"
                    required
                  />
                </FormField>
                <FormField>
                  <label>Date *</label>
                  <input
                    type="date"
                    name="date"
                    value={formData.date}
                    onChange={(e) => handleInputChange('date', e.target.value)}
                    required
                  />
                </FormField>
              </TwoColumns>
            </DeclarationContainer>
          </FormSection>
        );

      case 6:
        return (
          <FormSection>
            <FormHeader>
              <h3 className="section-title">Part B - Transport Details</h3>
              <p className="section-subtitle">
                To be completed by the person in charge of the sheep or lambs while they are being
                moved. Completion of this part is optional in SA and VIC.
              </p>
            </FormHeader>

            <TwoColumns>
              <FormField>
                <label>Movement commenced (Date/Time)</label>
                <input
                  type="datetime-local"
                  name="movement-commenced"
                  value={formData.movementCommenced}
                  onChange={(e) => handleInputChange('movementCommenced', e.target.value)}
                />
              </FormField>
              <FormField>
                <label>Vehicle registration number(s)</label>
                <input
                  type="text"
                  name="vehicle-registration"
                  value={formData.vehicleRegistration}
                  onChange={(e) => handleInputChange('vehicleRegistration', e.target.value)}
                  placeholder="Enter vehicle registration"
                />
              </FormField>
            </TwoColumns>

            <FormField>
              <label>
                I ___________________ am the person in charge of the sheep or lambs during
              </label>
              <input
                type="text"
                name="transporter-name"
                value={formData.transporterName}
                onChange={(e) => handleInputChange('transporterName', e.target.value)}
                placeholder="Name of person in charge"
                style={{ display: 'inline-block', width: '200px', margin: '0 10px' }}
              />
            </FormField>

            <p>the movement and declare all the information in Part B is true and correct.</p>

            <TwoColumns>
              <FormField>
                <label>Signature</label>
                <input
                  type="text"
                  name="transporter-signature"
                  value={formData.transporterSignature}
                  onChange={(e) => handleInputChange('transporterSignature', e.target.value)}
                  placeholder="Transporter signature"
                />
              </FormField>
              <FormField>
                <label>Date</label>
                <input
                  type="date"
                  name="transporter-date"
                  value={formData.transporterDate}
                  onChange={(e) => handleInputChange('transporterDate', e.target.value)}
                />
              </FormField>
            </TwoColumns>

            <FormField>
              <label>Tel no.</label>
              <input
                type="tel"
                name="transporter-tel"
                value={formData.transporterTelNo}
                onChange={(e) => handleInputChange('transporterTelNo', e.target.value)}
                placeholder="Enter telephone number"
              />
            </FormField>

            <div style={{ marginTop: '20px', fontSize: '12px', fontStyle: 'italic' }}>
              <p>
                *When more than one truck is carrying the sheep or lambs, other vehicle registration
                numbers are to be recorded.
              </p>
            </div>
          </FormSection>
        );

      default:
        return null;
    }
  };

  return (
    <CattleNvdWrapper>
      <FormTopHeader>
        <FormTitle>National Vendor Declaration (Sheep and Lambs) and Waybill</FormTitle>
        <p className="subtitle">
          This form cannot be used where eligibility for the EU market is required.
        </p>
      </FormTopHeader>

      <form onSubmit={handleSubmit}>
        <ButtonsWrapper>
          {currentStep > 0 && (
            <OutlineButton type="button" onClick={prevStep} style={{ maxWidth: 'fit-content' }}>
              ← Back
            </OutlineButton>
          )}

          {currentStep < steps.length - 1 ? (
            <OutlineButton type="button" onClick={nextStep}>
              Next →
            </OutlineButton>
          ) : (
            <OutlineButton type="submit">Submit NVD</OutlineButton>
          )}
        </ButtonsWrapper>

        <div className="form-content">{renderStep()}</div>
      </form>
    </CattleNvdWrapper>
  );
};

export default SheepNvd;
